// @flow strict
import React from 'react';
import { Timeline } from 'react-twitter-widgets';

type Props = {
  screenName: string,
  isIndex?: boolean,
};

const Twitter = ({ screenName, isIndex }: Props) => {
  if (!isIndex) {
    return (null);
  }
  return (<Timeline
            dataSource={{
              sourceType: 'profile',
              screenName: `${screenName}`
            }}
            options={{
              height: '400',
              width: '100%'
            }}
            />
  );
};


export default Twitter;
